import { useEffect, useRef, useState } from "react";

const ChatWidgetIframe = ({ pathName }) => {
  const iframeRef = useRef(null);
  const [isChatOpen, setIsChatOpen] = useState(false);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

   // const userToken = "144278f7-97fc-4e92-929d-3c0cb32e31f0";
     const userToken = localStorage.getItem('systemToken') || "";
    iframeDoc.open();
    iframeDoc.write(`
      <!DOCTYPE html>
      <html lang="en">
        <head>
          <style>
            html, body {
              margin: 0;
              padding: 0;
              width: 100%;
              height: 100%;
              overflow: hidden;
            }
            #caprock-chat-container {
              width: 100%;
              height: 100%;
            }
          </style>
        </head>
        <body>
          <div id="caprock-chat-container" data-token="${userToken}"></div>
          <script>
            window.CAPROCK_CONFIG = {
              userToken: '${userToken}'
            };

            const script = document.createElement('script');
            script.src = 'https://mapadmin.caprock.com.au/snippet/caprock-chat.js';
            script.async = true;
            script.onload = function() {
              const container = document.getElementById('caprock-chat-container');
              const token = window.CAPROCK_CONFIG?.userToken || container?.dataset.token || '';
              console.log('Initializing ChatWidget with token:', token ? token.substring(0, 8) + '...' : 'none');
              if (window.ChatbotWidget && window.ChatbotWidget.render) {
                window.ChatbotWidget.render(container, { token: token });
                 // Overwrite openChat and closeChat to also post a message
                               if (window.ChatbotWidget && window.ChatbotWidget.getIsChatOpen) {
                    console.log('ChatbotWidget open close is available!');
                    console.log('ChatbotWidget condition is!'+window.ChatbotWidget.getIsChatOpen());


    }else{
                    console.error('ChatbotWidget open close not available!');

    }
              } else {
                console.error('ChatbotWidget not loaded or render function not available!');
              }
            };
            document.body.appendChild(script);
          </script>
        </body>
      </html>
    `);
    iframeDoc.close();
    // Listen for messages from iframe
    const handleMessage = (event) => {
      if (event.data?.type === "CHAT_OPEN") {
        console.log("I am open");
        setIsChatOpen(true);
      }
      if (event.data?.type === "CHAT_CLOSE") {
        console.log("I am close");
        setIsChatOpen(false);
      }
    };
    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  return (
    <iframe
      ref={iframeRef}
      title="Caprock Chat Widget"
      className={`bottom-[5vh] fixed bottom-4 right-14 z-[100]
   
    ${
      isChatOpen
        ? "h-[600px] md:h-[500px] w-[100%] md:w-[400px] max-w-[100%]"
        : "h-[100px] w-[30%] md:w-[100px] max-w-[100%]"
    }
    `}
      style={{ border: "none", pointerEvents: "auto" }}
    />
  );
};

export default ChatWidgetIframe;
